import { useState } from 'react';
import { PaymentMethodTypes } from '../../constants';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import {
  selectPaymentData,
  getDataRequiredAsync,
  clearPaymentSelected,
  selectPaymentMethodSelected,
  selectConfirmPayment,
  selectDataRequired,
} from 'features/payment/payment-slice';
import PaymentType from 'components/payment-type';
import { useTranslation } from 'react-i18next';
import APMSection from './apm-section';
import CardSection from './card-section';
import PaymentInfo from 'components/payment-info';
import { useMediaQuery } from '@mui/material';
import styles from './styles.module.scss';
import { Urls } from 'config/urls';
import MoreIcon from '@mui/icons-material/Add';
import { TermsAndConditions } from 'components/terms-and-conditions';

const CheckoutContent = () => {
  const { t } = useTranslation();
  const isDesktop = useMediaQuery('(min-width:1024px)');
  const dispatch = useAppDispatch();
  const paymentData = useAppSelector(selectPaymentData);
  const paymentMethodSelected = useAppSelector(selectPaymentMethodSelected);
  const confirmPayment = useAppSelector(selectConfirmPayment);
  const dataRequired = useAppSelector(selectDataRequired);
  const [paymentTypeSelected, setPaymentTypeSelected] = useState<PaymentMethodTypes | string>('');
  const paymentMethodsGrouped = paymentData?.paymentMethodsGrouped;

  return (
    <div className={styles.checkout_content}>
      {!isDesktop && <PaymentInfo collapsible />}
      <div className={styles.checkout_content_box}>
        <div
          className={`${styles.checkout_content_data} ${
            dataRequired.loading || confirmPayment.loading ? styles.checkout_content_data_disabled : ''
          }`}
        >
          <div className={styles.checkout_content_title}>{t('checkoutContent.title')}</div>
          {paymentMethodsGrouped &&
            Object.keys(paymentMethodsGrouped).map((key, groupId) => (
              <PaymentType
                key={groupId}
                title={t(
                  `paymentMethods.type.${key}${
                    PaymentMethodTypes.VOUCHER === key && paymentData.country === 'UY' ? '.UY' : ''
                  }`
                )}
                summary={
                  <div className={styles.checkout_content_summary}>
                    {paymentMethodsGrouped[key].slice(0, 3).map(pm => (
                      <img
                        key={pm.code}
                        src={`${Urls.paymentMethodsSquare.replace(':code', pm.code)}`}
                        className={styles.checkout_content_summary_logo}
                        alt="pm-logo"
                      />
                    ))}
                    {paymentMethodsGrouped[key].length > 3 && <MoreIcon sx={{ fontSize: '12px' }} />}
                  </div>
                }
                content={
                  PaymentMethodTypes.VOUCHER === paymentTypeSelected && paymentTypeSelected === key ? (
                    <APMSection
                      paymentMethodSelected={paymentMethodSelected}
                      paymentMethos={paymentMethodsGrouped[key]}
                      onChange={pm => dispatch(getDataRequiredAsync(pm))}
                    />
                  ) : PaymentMethodTypes.BANK_TRANSFER === paymentTypeSelected && paymentTypeSelected === key ? (
                    <APMSection
                      paymentMethodSelected={paymentMethodSelected}
                      paymentMethos={paymentMethodsGrouped[key]}
                      onChange={pm => dispatch(getDataRequiredAsync(pm))}
                    />
                  ) : PaymentMethodTypes.CREDIT_CARD === paymentTypeSelected && paymentTypeSelected === key ? (
                    <CardSection />
                  ) : (
                    <div />
                  )
                }
                expanded={paymentTypeSelected === key}
                onChange={() => {
                  dispatch(clearPaymentSelected());
                  setPaymentTypeSelected(paymentTypeSelected === key ? '' : key);
                }}
              />
            ))}
          {!isDesktop && <TermsAndConditions />}
        </div>
        {isDesktop && (
          <div className={styles.checkout_content_info}>
            <PaymentInfo />
          </div>
        )}
      </div>
    </div>
  );
};

export default CheckoutContent;
